import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Response } from '../models/Response';
import { Wallet, WalletWithStats } from '../models/Wallet';
import { WalletTransaction, RechargeRequest, RefundRequest, AdjustmentRequest } from '../models/WalletTransaction';

@Injectable({
  providedIn: 'root'
})
export class WalletService {
  private baseUrl = `${environment.API_URL}/wallet`;

  constructor(private http: HttpClient) { }

  /**
   * Obtener el wallet y estadísticas de un usuario
   */
  /**
   * Obtener el wallet y estadísticas de un usuario
   */
  getWallet(userId: number, productId?: number | null): Observable<Response<WalletWithStats>> {
    const params: any = {};
    if (productId) params.product_id = productId;
    return this.http.get<Response<WalletWithStats>>(`${this.baseUrl}/${userId}`, { params });
  }

  /**
   * Obtener historial de transacciones
   */
  getTransactions(userId: number, limit: number = 50, productId?: number | null): Observable<Response<WalletTransaction[]>> {
    const params: any = { limit: limit.toString() };
    if (productId) params.product_id = productId;
    return this.http.get<Response<WalletTransaction[]>>(
      `${this.baseUrl}/${userId}/transactions`,
      { params }
    );
  }

  /**
   * Recargar saldo al wallet (solo admin)
   */
  recharge(userId: number, data: RechargeRequest): Observable<Response<WalletTransaction>> {
    return this.http.post<Response<WalletTransaction>>(
      `${this.baseUrl}/${userId}/recharge`,
      data
    );
  }

  /**
   * Realizar un ajuste manual del saldo (solo admin)
   */
  adjustment(userId: number, data: AdjustmentRequest): Observable<Response<WalletTransaction>> {
    return this.http.post<Response<WalletTransaction>>(
      `${this.baseUrl}/${userId}/adjustment`,
      data
    );
  }

  /**
   * Reembolsar al wallet (solo admin)
   */
  refund(userId: number, data: RefundRequest): Observable<Response<WalletTransaction>> {
    return this.http.post<Response<WalletTransaction>>(
      `${this.baseUrl}/${userId}/refund`,
      data
    );
  }

  /**
   * Realizar un cargo manual (solo admin)
   */
  charge(userId: number, data: { amount: number; concept: string; product_id?: number | null }): Observable<Response<WalletTransaction>> {
    return this.http.post<Response<WalletTransaction>>(
      `${this.baseUrl}/${userId}/charge`,
      data
    );
  }

  /**
   * Comprar prácticas (solo admin)
   */
  buyPractices(userId: number, data: { number_of_practices: number; amount: number; concept: string; product_id?: number | null }): Observable<Response<WalletTransaction>> {
    return this.http.post<Response<WalletTransaction>>(
      `${this.baseUrl}/${userId}/buy-practices`,
      data
    );
  }

  /**
   * Formatear el tipo de transacción para mostrar
   */
  getTransactionTypeLabel(type: string): string {
    const labels: { [key: string]: string } = {
      'recharge': 'Recarga',
      'charge': 'Cargo',
      'refund': 'Reembolso',
      'adjustment': 'Ajuste'
    };
    return labels[type] || type;
  }

  /**
   * Obtener el color según el tipo de transacción
   */
  getTransactionTypeColor(type: string): string {
    const colors: { [key: string]: string } = {
      'recharge': 'success',
      'charge': 'danger',
      'refund': 'info',
      'adjustment': 'warning'
    };
    return colors[type] || 'secondary';
  }

  /**
   * Formatear el monto con signo
   */
  formatAmount(amount: number | string): string {
    const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
    if (isNaN(numAmount)) {
      return '0.00€';
    }
    const sign = numAmount >= 0 ? '+' : '';
    return `${sign}${numAmount.toFixed(2)}€`;
  }
}
